// src/services/storyMentions.js
//
// Hikaye overlay'lerindeki @mention sticker'larını bildirime çevirir.
// Gizlilik koruması INSTAGRAM-P1-11 deseniyle aynı (postMentions.js):
// hedef GİZLİ hesapsa bildirim ancak bahseden onaylı takipçisiyse gider.
// Fire-and-forget — hikaye paylaşım akışını bildirim hatası bozmaz.

import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { notifyStoryMention } from "./notifications";

async function allowedByPrivacy(
  mentionedUid: string,
  mentionerUid: string,
): Promise<boolean> {
  try {
    const uSnap = await getDoc(doc(db, "users", String(mentionedUid)));
    if ((uSnap.data() || {}).isPrivate !== true) return true;
    const edgeSnap = await getDoc(
      doc(db, "users", String(mentionedUid), "followers", String(mentionerUid))
    );
    return edgeSnap.exists();
  } catch {
    return true; // fail-open — block katmanı ayrı çalışır
  }
}

/** Mention sticker'ının taşıdığı hedef. `uid` yoksa overlay elenir. */
export type StoryMention = { uid?: string };

/**
 * Hikaye overlay'i — bu servis YALNIZ `type` ve `payload.mention` alanlarını
 * okur (overlay'in tamamı composer tarafında çok daha geniştir).
 */
export type StoryMentionOverlay = {
  type?: string;
  payload?: { mention?: StoryMention } | null;
};

/**
 * Overlay listesindeki mention'lara bildirim yazar.
 *
 * @param authorUid hikaye sahibi (mentionlayan)
 */
export async function notifyMentionsInStoryOverlays(
  storyId: string,
  overlays: Array<StoryMentionOverlay | null | undefined> | null | undefined,
  authorUid: string,
  // `notifyStoryMention` bunu `authorUsername?: string` olarak alıyor;
  // çağıran (`Hikayeler`) profilden geldiği için `undefined` olabiliyor.
  authorUsername: string | undefined,
): Promise<void> {
  try {
    const mentions = (overlays || [])
      .filter((o) => o?.type === "mention" && o?.payload?.mention?.uid)
      // Yukarıdaki `filter` `payload.mention.uid`i zaten doğruladı; TS bu
      // bilgiyi filtre üzerinden taşıyamıyor → guard EKLENMEZ, tip daraltılır.
      .map((o) => (o!.payload as { mention: StoryMention }).mention);
    if (!mentions.length) return;

    const seen = new Set<string>();
    await Promise.all(
      mentions.map(async (m) => {
        if (!m.uid || m.uid === authorUid || seen.has(m.uid)) return;
        seen.add(m.uid);
        const ok = await allowedByPrivacy(m.uid, authorUid);
        if (!ok) return;
        await notifyStoryMention({ storyId, mentionedUid: m.uid, authorUsername });
      })
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    const hata = err as { message?: string } | null | undefined;
    console.warn("[storyMentions] bildirim akışı hatası:", hata?.message || err);
  }
}
